import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) { toast.success("Welcome back"); nav("/app"); }
    else toast.error(res.error || "Login failed");
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      <div className="hidden md:block relative">
        <img src="https://images.unsplash.com/photo-1455390582262-044cdead277a?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200" alt="Handwritten letter" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-tr from-[#2D4A3E]/40 to-transparent" />
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <h2 className="font-display text-3xl font-bold tracking-tight">Quietly apply everywhere.</h2>
          <p className="text-sm opacity-80 mt-2">Reach the companies that fit — before they even post a role.</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-8 bg-[#FDFDFB]">
        <div className="w-full max-w-md">
          <Link to="/" className="flex items-center mb-10">
            <Logo />
          </Link>
          <div className="overline">Sign in</div>
          <h1 className="font-display text-3xl font-bold tracking-tight mt-2">Welcome back</h1>
          <form onSubmit={submit} className="mt-8 space-y-5">
            <div><Label htmlFor="email" className="text-sm">Email</Label>
              <Input id="email" data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-11 rounded-lg" /></div>
            <div><Label htmlFor="password" className="text-sm">Password</Label>
              <Input id="password" data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-11 rounded-lg" /></div>
            <Button type="submit" data-testid="login-submit" disabled={loading} className="w-full h-11 rounded-full bg-[#2D4A3E] hover:bg-[#3B5F50]">{loading ? "Signing in…" : "Sign in"}</Button>
          </form>
          <div className="mt-6 text-sm text-[#5C6661]">
            No account? <Link to="/register" data-testid="link-register" className="text-[#2D4A3E] font-medium hover:underline">Create one</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
